import { DividerWithTextProps } from "../types/modules/DividerWithTextTypes"

export const defaultContainerStyle = 'flex items-center w-full h-[32px]'
export const defaultDividerLineStyle = 'w-1/2 !border-gray-700 border-.5'
export const defaultTextStyle = 'px-[9px] text-gray-500 text-[16px]'
export const defaultText = 'or'

export const DividerWithText: React.FC<DividerWithTextProps> = (props: DividerWithTextProps) => {
  const { containerStyle, dividerLineStyle, textStyle, text } = props;
  return (
    <div className={containerStyle || defaultContainerStyle}>
      <hr className={dividerLineStyle || defaultDividerLineStyle}></hr>
      <span className={textStyle || defaultTextStyle}>{text || defaultText}</span>
      <hr className={dividerLineStyle || defaultDividerLineStyle}></hr>
    </div>   
  )
}